import { render, staticRenderFns } from "./pricingmanagement.vue?vue&type=template&id=d0e6f968&scoped=true"
import script from "./pricingmanagement.vue?vue&type=script&lang=js"
export * from "./pricingmanagement.vue?vue&type=script&lang=js"
import style0 from "./pricingmanagement.vue?vue&type=style&index=0&id=d0e6f968&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e6f968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0e6f968')) {
      api.createRecord('d0e6f968', component.options)
    } else {
      api.reload('d0e6f968', component.options)
    }
    module.hot.accept("./pricingmanagement.vue?vue&type=template&id=d0e6f968&scoped=true", function () {
      api.rerender('d0e6f968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commodityreference/pricingmanagement/pricingmanagement.vue"
export default component.exports